export const parsePrice = (value) => {
  try {
    const prices = typeof value === "string" ? JSON.parse(value) : value;
    const hour = new Date().getHours();
    const price = Array.isArray(prices)
      ? prices[prices.length > 1 && (hour < 6 || hour >= 18) ? 1 : 0]
      : prices;
    return Number(price) || 0;
  } catch { return 0; }
};

  export const getCurrentDateTimeJson = () => {
    const currentTime = new Date();
    return {
      date: currentTime.toLocaleDateString("en-US"),
      time: currentTime.toLocaleTimeString("en-US"),
    };
  };
  
  export const getFormattedCreationTime = () => {
    return new Date().toLocaleString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    });
  };
  